<template>
  <div class="container">
    <button class="button is-primary is-small is-pulled-right" @click="add">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Cadastrar</span>
    </button>
    <br><br>

    <div class="modal" :class="{ 'is-active': isProcessing }">
      <div class="modal-background"></div>
      <div class="modal-content has-text-centered">
        <progress class="progress is-primary is-large" max="100"></progress>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">
            {{ mostraImportarModelo ? 'Importar Versão' : 'Cadastrar Versão' }}
          </p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraImportarModelo">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição da versão" v-model="versaoPlanoContas.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Vigência</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="date" placeholder="Informe a vigência" v-model="versaoPlanoContas.vigencia">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Comentários</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Comente sobre essa versão" v-model="versaoPlanoContas.comentario"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraImportarModelo">
            <div class="field">
              <label class="label">Selecione um modelo para importação</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="cmbModeloParaImportacao">
                    <option value="-1">ANS (Modelo)</option>
                    <option value="-2">Gerencial (Modelo)</option>
                    <option
                      v-for="versao in versoesPlanosContas"
                      :key="versao.id"
                      :value="versao.id"
                      :disabled="versao.id === versaoPlanoContasSelecionado?.id"
                    >
                      {{ versao.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="mostraImportarModelo ? importar() : save()">
            {{ mostraImportarModelo ? 'Importar' : 'Salvar' }}
          </button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns is-centered" v-show="showInfo">
      <div class="column is-10">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">
              Versões
            </p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th>Vigência</th>
                    <th class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(versaoPlanoContas, index) in versoesPlanosContas" :key="versaoPlanoContas.id">
                    <td>{{ versaoPlanoContas.descricao }}</td>
                    <td>{{ versaoPlanoContas.vigencia | dateDDMMYYYY }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-primary is-outlined" @click="importarModelo(versaoPlanoContas)" title="Importar modelo">
                          <span class="icon is-small">
                            <i class="fas fa-file-import"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config'
import moment from 'moment'

export default {
  name: "PlanoDeContas",
  data() {
    return {
      versaoPlanoContas: {
        id: null,
        descricao: null,
        vigencia: null,
        usuario: null,
        comentario: null
      },
      versoesPlanosContas: [],
      isShowModal: false,
      isProcessing: false,
      versaoPlanoContasSelecionado: null,
      mostraImportarModelo: false,
      cmbModeloParaImportacao: '-1',
      showInfo: true
    }
  },
  methods: {
    callListAPI(nome) {
      http.get(nome).then(response => {
        this.versoesPlanosContas = response.data.results
      })
    },
    importarModelo(versaoPlanoContas) {
      this.versaoPlanoContasSelecionado = versaoPlanoContas
      this.mostraImportarModelo = true
      this.isShowModal = true
    },
    clearFields() {
      this.versaoPlanoContas = {
        id: null,
        descricao: null,
        vigencia: null,
        usuario: null,
        comentario: null,
        index: null
      }
    },
    importar() {
      if (window.confirm('Confirma importação do modelo selecionado?')) {
        this.isProcessing = true
        this.isShowModal = false
        http.put('/versoesPlanoContas/importarModelo/' + this.versaoPlanoContasSelecionado.id, this.cmbModeloParaImportacao)
          .then(response => {
            if (response.status === 200) {
              alert('Importação do modelo selecionado foi concluída!')
            } else if (response.status === 204) {
              alert('Arquivo não carregado! Possíveis motivos: Não informado ou não são do tipo XLSX.')
            }
            this.isProcessing = false
            this.isShowModal = true
          })
          .catch(e => {
            this.isProcessing = false
            this.isShowModal = true
            console.log(e)
          })
      }
    },
    add() {
      this.clearFields()
      this.isShowModal = true
    },
    edit(index) {
      this.versaoPlanoContas.id = this.versoesPlanosContas[index].id
      this.versaoPlanoContas.descricao = this.versoesPlanosContas[index].descricao
      this.versaoPlanoContas.vigencia = this.versoesPlanosContas[index].vigencia
      this.versaoPlanoContas.comentario = this.versoesPlanosContas[index].comentario
      this.versaoPlanoContas.usuario = this.versoesPlanosContas[index].usuario
      this.versaoPlanoContas.index = index
      this.isShowModal = true
    },
    erase(index) {
      if (window.confirm('Confirma exclusão?')) {
        http.delete('/versoesPlanoContas/excluir/' + this.versoesPlanosContas[index].id)
          .then(response => {
            this.versoesPlanosContas.splice(index, 1)
            if (response.status === 204) {
              alert('Registro excluído!')
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    save() {
      if (!this.versaoPlanoContas.descricao) {
        alert('Descrição da versão não preenchida!')
        return
      }
      if (!this.versaoPlanoContas.vigencia || this.versaoPlanoContas.vigencia === "Invalid date") {
        alert('Vigência não preenchida!')
        return
      }

      const data = {
        id: this.versaoPlanoContas.id,
        descricao: this.versaoPlanoContas.descricao,
        vigencia: moment(this.versaoPlanoContas.vigencia).format('DD/MM/YYYY'),
        comentario: this.versaoPlanoContas.comentario,
        usuario: this.$store.state.idUser
      }

      const formData = new FormData()
      Object.keys(data).forEach(key => formData.append(key, data[key]))

      if (this.versaoPlanoContas.id == null) {
        http.post('/versoesPlanoContas/adicionar', formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
          .then(response => {
            if (response.data.id) {
              this.versaoPlanoContas.id = response.data.id
              this.versoesPlanosContas.push({ ...this.versaoPlanoContas })
              this.showInfo = true
              this.clearFields()
              // this.isShowModal = false
            } else {
              alert(response.request.responseText)
            }
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        http.put('/versoesPlanoContas/editar/' + this.versaoPlanoContas.id, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
          .then(response => {
            this.versoesPlanosContas[this.versaoPlanoContas.index].comentario = this.versaoPlanoContas.comentario
            this.versoesPlanosContas[this.versaoPlanoContas.index].descricao = response.data.descricao
            this.versoesPlanosContas[this.versaoPlanoContas.index].vigencia = this.versaoPlanoContas.vigencia
            this.isShowModal = false
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  },
  mounted() {
    this.callListAPI('versoesPlanoContas/listar')
  },
}
</script>

<style scoped>
</style>